export const TITLE = 'Welcome to MobileMonkey!';
export const SUB_TITLE =
  "We're excited to have you onboard. Let's get started.";
export const OTHER_OPTION = 'Other';

const AD_SPENT_OPTIONS = [
  'None',
  '$1 - $999',
  '$1,000 - $2,499',
  '$2,500 - $4,999',
  '$5,000 - $9,999',
  '$10,000 - $19,999',
  '$20,000 - $49,999',
  '$50,000 - $99,999',
  '$100,000+',
];

const CRM_OPTIONS = [
  'None',
  'Salesforce',
  'HubSpot',
  'InfusionSoft',
  OTHER_OPTION,
];

export const EMPLOYEE_COUNT_LOOKUP = {
  'I don’t have a marketing team': '0-0',
  'It’s just me': '1-1',
  '2': '2-2',
  '3-4': '3-4',
  '5-9': '5-9',
  '10+': '10-5000',
};

const EMPLOYEE_COUNT_OPTIONS = [
  'I don’t have a marketing team',
  'It’s just me',
  '2',
  '3-4',
  '5-9',
  '10+',
];

const JOB_ROLE = [
  'Business Owner',
  'Marketing',
  'Creator or Coach',
  'Agency Marketer',
  'Sales',
];

const DEAL_SIZE = ['$1-$249', '$250-$3999', '$4000+'];

const AD_BUDGET = [
  'I’m not running ads',
  '< $500',
  '$500-$2,499',
  '$2,500-$14,999',
  '$15,000+',
];

const EXPERIENCE_WITH_CHAT = [
  'I’m just starting out',
  'I’ve used another chat platform',
  'I’ve used MobileMonkey',
];

const GOAL_OPTIONS = [
  'Build an email list',
  'Re-engage on SMS/social',
  'Qualify leads',
  'Improve Return on Ad Spend',
  'Handle message volume',
  'Customer Service',
  'Generate appointments',
  'Sell products or services',
  OTHER_OPTION,
];

export const adSpendOptions = AD_SPENT_OPTIONS.map(option => ({
  id: option,
  name: option,
}));

export const crmOptions = CRM_OPTIONS.map(option => ({
  id: option,
  name: option,
}));

export const jobRoleOptions = JOB_ROLE.map(option => ({
  id: option,
  name: option,
}));

export const dealSizeOptions = DEAL_SIZE.map(option => ({
  id: option,
  name: option,
}));

export const adBudgetOptions = AD_BUDGET.map(option => ({
  id: option,
  name: option,
}));

export const experienceWithChatOptions = EXPERIENCE_WITH_CHAT.map(option => ({
  id: option,
  name: option,
}));

export const goalOptions = GOAL_OPTIONS.map(option => ({
  id: option,
  name: option,
}));

export const employeeCountOptions = EMPLOYEE_COUNT_OPTIONS.map(
  (option: keyof typeof EMPLOYEE_COUNT_LOOKUP) => ({
    id: option,
    name: option,
  }),
);
